import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

import ChartCard from '../../ChartComponents/ChartCard';
import BarChart from '../../ChartComponents/BarChart';
import Info from '../../../../components/Info';
import { getPercentage } from '../../utils';

const SourceChart = ({ inboundSources }) => {
  const [chartData, setChartData] = useState([]);
  useEffect(() => {
    if (!isEmpty(inboundSources)) {
      const totalAmount = inboundSources.reduce((prev, curr) => (prev + curr.count), 0);
      const newChartData = [];
      inboundSources.forEach((item) => {
        newChartData.push({
          name: item.inboundSource,
          total: item.count,
          percentage: getPercentage(item.count, totalAmount),
        });
      });
      setChartData(newChartData);
    }
  }, [inboundSources]);

  if (inboundSources?.length > 1) {
    return (
      <ChartCard
        title={(
          <Info
            label="Sources"
            content="The number of sources that are used to produce the snapshots (e.g. QR Code, URL, etc...)"
            className="ml-2"
          />
        )}
      >
        <BarChart
          data={chartData}
          dataKey="name"
          labelKey="percentage"
          xAxisKey="name"
          barKey="total"
          barColor="var(--theme-yellow-dark)"
          renderLabel
        />
      </ChartCard>
    );
  }

  return null;
};

export default connect(
  ({
    analytics: {
      basic: {
        data: {
          inboundSources,
        },
      },
    },
  }) => ({
    inboundSources,
  }),
)(SourceChart);
